import React from 'react';
import PropTypes from 'prop-types';
import 'src/containers/SectionContainer.scss';


const PopularContainer = ({ children, title, dataTestName }) => (
  <div data-test={ dataTestName } styleName="section-container">
    <div styleName="section-container__header">
      <h2 styleName="header__primary">
        { title }
      </h2>
    </div>
    { children }
  </div>
);

PopularContainer.propTypes = {
  children: PropTypes.node.isRequired,
  dataTestName: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};

export default PopularContainer;
